import ErrorState from './ErrorState';
import React from 'react';
import { useTranslation } from 'react-i18next';

function IndexError() {
	const { t } = useTranslation();
	return (
		<ErrorState>
			<h1>{t('index.error.title')}</h1>
			<p>{t('common.error.occur')}</p>
			<p className='error-state__wrapper__retry'>{t('common.error.retry')}</p>
		</ErrorState>
	);
}

export default IndexError;
